import { render } from "./CancelPage.vue?vue&type=template&id=4ef6b414&scoped=true"
import script from "./CancelPage.vue?vue&type=script&lang=ts"
export * from "./CancelPage.vue?vue&type=script&lang=ts"

import "./CancelPage.vue?vue&type=style&index=0&id=4ef6b414&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ef6b414"

export default script